// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","532":"styles","774":"framework","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"36":"93aa6ee0008363b7ba1f","231":"8ae67609999f4075e88f","351":"ec244a8f71f989a38762","532":"8ba365ef3bdfb8a79120","774":"f5d50277d5e7dc8e82b4","883":"f3e4dda9e88061b2f2fa"}[chunkId] + ".js";
};